import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { formFooterHeight } from '~/utilities';

export const FeedbackMainContainerStyled = styled(Box).attrs({
  p: { sm: '400' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    height: calc(100% - ${formFooterHeight}px);
    background-color: ${theme.colors.grey[100]};
  `}
`;
export const FeedbackCardStyled = styled(Box).attrs({
  p: { sm: '500' },
  flexGrow: { sm: '1' },
})`
  ${({ theme }) => css`
    border-radius: ${theme.radii[400]};
    background-color: white;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `}
`;
export const FormContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 72%;
`;
